import { Button } from '@/components/UI';
import Image from '@/components/UI/Image';
import { CopyIcon, ExpandArrowBottom } from '@/components/UI/svg/Ecocredits';
import { FormatMoney } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { useCountDown } from 'ahooks';
import { Tooltip } from 'antd';
import { reduce } from 'lodash';
import moment from 'moment';
import { useRouter } from 'next/router';
import { FC } from 'react';
import css from './index.module.scss';
interface CouponModel {
    coupon?: string; // 优惠券劵code
    amount?: string; // 优惠券金额
    currencySymbol?: string; // 货币符号
    points?: number; // 兑换优惠券所需积分数量
    campaignId?: string; // 活动id
    campaignEndTime: string; // 活动结束时间
    campaignName: string; // 活动名称
    discountType: 'fixed_amount' | 'percentage'; // 折扣类型
    ruleType: string; // 积分类型(COUPONS;FREE_SHIPPING;FREE_PRODUCTS;GIFT_CARD)
    birthdayFlag?: 0 | 1; // 0 禁用 1启用
    source: string; // 积分场景(COUPONS_PRODUCTS;COUPONS_ORDERS)
    source2: string; // 积分场景2
    picUrl?: string; // 后台上传icon
    rulePic?: string; // 后台上传产品图片
    useStatus?: string;
    goodTitle?: string; // 产品名称
    couponName?: string; // 第三方优惠券名称
    orderName?: string; // 产品订单id
    receiveStatus?: 1 | 2 | 3;
    stock?: number; // 库存
    discountId?: string; // discountId
    variantTitle?: string; // 变体名称
    useUrl?: string; // 第三方优惠券跳转链接

    // 前端添加状态
    minimum_rule?: string;
    noteList: string[];
}

interface CouponProps {
    coupon: CouponModel;
    className?: string;
    disabled?: boolean;
    disabledBtn?: boolean;
    btnText?: string;
    hideNote?: boolean;
    hideBtn?: boolean;
    hideAmount?: boolean;
    hideCopyIcon?: boolean;
    showCountDown?: boolean;
    showstock?: boolean;
    showJumpBtn?: boolean;
    onReedem?: (coupon: CouponModel) => void | Promise<any>;
    onViewsRules?: (rules: CouponModel) => void;
    onClickCard?: (coupon: CouponModel) => void;
}

const getConponBg = (coupon: CouponModel, isMobile: boolean) => {
    const { ruleType, useStatus, receiveStatus = 1 } = coupon || {};
    const isUsed = (useStatus && useStatus !== 'UNUSED') || (receiveStatus && receiveStatus !== 1);
    if (ruleType === 'COUPONS' && coupon?.rulePic) {
        return coupon?.rulePic;
    }
    if (ruleType === 'COUPONS') {
        return `/icons/ecocredits/${isMobile ? 'm_' : ''}conpon${isUsed ? '_used' : ''}.svg`;
    }
    return `/icons/ecocredits/${isMobile ? 'm_' : ''}conpon.svg`;
};

const isAllTrue = (...params: any) => {
    const arr = Array.from(params);
    return arr.every((i) => !!i);
};

const Coupon: FC<CouponProps> = ({
    coupon,
    className,
    disabled,
    disabledBtn,
    btnText,
    hideNote,
    hideBtn,
    hideAmount,
    showCountDown,
    hideCopyIcon = false,
    showstock = false,
    showJumpBtn = false,
    onReedem,
    onViewsRules,
    onClickCard,
}) => {
    const { useState, useLang, isMobile, Link, gtm } = useGlobal();
    const { t } = useLang('membersstore');
    const { locale, pathname } = useRouter();
    const [loading, setLoading] = useState(false);

    // 倒计时

    const { campaignEndTime } = coupon;
    const isStartCountDown = showCountDown && !coupon?.discountId && coupon?.campaignEndTime;
    const targetDate = isStartCountDown ? moment(Number(campaignEndTime)).toString() : undefined;
    const [_countdown, { days, hours, minutes, seconds }] = useCountDown({ targetDate });

    const ruleTypeMap: { [key: string]: string } = {
        COUPONS: t('coupon'),
    };

    const useStatusMap: { [key: string]: string } = {
        UNUSED: t('available'),
        USED: t('redeemed'),
        EXPIRED: t('expired'),
    };

    const receiveStatusMap: { [key: string]: string } = {
        1: 'UNUSED',
        2: 'USED',
        3: 'EXPIRED',
    };

    const { useStatus, receiveStatus } = coupon || {};

    const useStatusC = useStatus ? useStatus : receiveStatusMap[receiveStatus || 1];

    const getCouponName = (coupon: CouponModel) => {
        const { ruleType, goodTitle, variantTitle, couponName } = coupon || {};

        // 优先使用couponName字段
        if (couponName) {
            return couponName;
        } else if (ruleTypeMap[ruleType]) {
            // 优惠券&礼品卡
            return ruleTypeMap[ruleType];
        } else if (ruleType === 'FREE_PRODUCTS') {
            // 实体产品
            return variantTitle ? `${goodTitle}-${variantTitle}` : goodTitle;
        } else {
            return '';
        }
    };

    const _onReedem = async (coupon: CouponModel) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'activity_redeem',
            page_name: `/${locale}${pathname}`,
            list_name: 'Redeem EcoCredits Rewards',
            content: coupon?.amount,
            button_name: t('redeem_now'),
        });
        if (!onReedem) return;

        setLoading(true);
        await onReedem(coupon);
        setLoading(false);
    };

    const copyText = (text?: string) => {
        if (!text) return;

        if (navigator?.clipboard && window?.isSecureContext) {
            window.navigator.clipboard.writeText(text);
        } else {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'absolute';
            textArea.style.opacity = '0';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.select();
            new Promise(() => {
                const copyStatus = document.execCommand('copy');
                if (!copyStatus) {
                    // message.error()
                }
                textArea.remove();
            });
        }
    };

    const statusClassNames = {
        hideNote,
        hideBtn,
        disabled,
        showJumpBtn,
    };

    const formatTime = (time?: number) => {
        if (typeof time !== 'number') {
            return time;
        }

        if (time < 10 && time >= 0) {
            return `0${time}`;
        }

        return time;
    };

    const cls = reduce(
        statusClassNames,
        (res, val, key) => {
            if (val) {
                return `${res} ${key}`;
            }
            return res;
        },
        '',
    );

    return (
        <div
            className={`${css.coupon_card} ${coupon.ruleType} ${useStatusC} ${className} ${cls}`}
            onClick={() => {
                if (!coupon?.coupon) return;
                copyText(coupon?.coupon);
                onClickCard && onClickCard(coupon);
            }}
        >
            <div className="top">
                {/* 背景 */}
                <div className="bg">
                    <Image src={getConponBg(coupon, isMobile)} layout="fill" alt="" />
                </div>
                {/* 产品图 */}
                {coupon.ruleType !== 'COUPONS' && coupon.rulePic && (
                    <div className="product_pic">
                        <Image src={coupon.rulePic} layout="fill" alt="" />
                    </div>
                )}
                {/* 状态 */}
                <div className="reward-status">
                    <Image src="/img/ecocredits/pc/shape_bg.png" layout="fill" alt="" />
                    <span className="status-text">{useStatusMap[useStatusC] || coupon?.useStatus}</span>
                </div>

                {/* 库存 */}
                {showstock && typeof coupon?.stock !== 'undefined' && <span className="stock">{t('stock_left', { stock: coupon.stock })}</span>}

                {/* 金额 */}
                {!hideAmount && (
                    <div className={`amont ${coupon.discountType}`}>
                        <div className="amount-content">
                            {FormatMoney(Number(coupon?.amount))}
                            {coupon?.ruleType === 'GIFT_CARD' ? (
                                coupon?.currencySymbol || '$'
                            ) : (
                                <div className="info">
                                    <p className="unit">{coupon.discountType === 'percentage' ? '%' : coupon?.currencySymbol || '$'}</p>
                                    <p className="off-text">{t('off')}</p>
                                </div>
                            )}
                        </div>

                        {coupon?.minimum_rule && <span className="minimum_rule">{coupon?.minimum_rule}</span>}
                    </div>
                )}
            </div>

            {/* company图标 */}
            {coupon?.picUrl && (
                <div className="reward_icon">
                    <Image src={coupon?.picUrl} layout="fill" alt="" />
                </div>
            )}

            <div className="box-center">
                {/* 优惠券名称 */}
                <Tooltip title={getCouponName(coupon)}>
                    <p className="type">{getCouponName(coupon)}</p>
                </Tooltip>

                {/* 实体产品订单id */}
                {isAllTrue(coupon?.orderName) && (
                    <div className="order-info">
                        <span>{t('order_text')}: </span>
                        <Link className="order-id" href={`https://${locale}.ecoflow.com/account`}>
                            {coupon?.orderName}
                        </Link>
                    </div>
                )}
                {/* 券码 */}
                {isAllTrue(coupon?.coupon, !coupon?.orderName) && (
                    <div className="reward-key">
                        <span>{coupon?.coupon}</span>
                        {!hideCopyIcon && (
                            <i onClick={() => copyText(coupon?.coupon)}>
                                <CopyIcon />
                            </i>
                        )}
                    </div>
                )}
                {/* 兑换订单所需积分 */}
                {isAllTrue(coupon?.points, !coupon?.coupon, !coupon?.orderName) && (
                    <p className="points">
                        <span>{coupon.points}</span> <span className="unit">{t('points')}</span>
                    </p>
                )}
            </div>

            {/* 优惠券规则 */}
            {!hideNote && (
                <div className="note-content">
                    <div className="note-action">
                        <span
                            className="hide"
                            onClick={(e) => {
                                e.stopPropagation();
                                onViewsRules && onViewsRules(coupon);
                            }}
                        >
                            {t('rules')}
                        </span>
                        <span
                            // className={`icon ${rule?.showMore ? 'showMore' : ''}`}
                            className={`icon`}
                            onClick={(e) => {
                                e.stopPropagation();
                                onViewsRules && onViewsRules(coupon);
                            }}
                        >
                            <ExpandArrowBottom />
                        </span>
                    </div>
                </div>
            )}

            {/* 倒计时 */}
            <div className="count-down">
                {isStartCountDown && `${formatTime(days)} : ${formatTime(hours)} : ${formatTime(minutes)} : ${formatTime(seconds)}`}
            </div>

            {/* 兑换按钮 */}
            {!hideBtn && (
                <div className="btn-wrapper">
                    <Button loading={loading} onClick={() => _onReedem(coupon)} disabled={disabled || disabledBtn} className="redeem-now">
                        {btnText || t('redeem_now')}
                    </Button>
                </div>
            )}
        </div>
    );
};

export default Coupon;
